import React from 'react'
import "./StepsHeadingSection.css"
import Progress from '../CreateCampaign/Progress/Progress'

const StepsHeadingSection = ({stepNumber, people}) => {
  return (
    <div className={stepNumber ? "progressC-headingSection" : "c-headingSection"}>
      <div>
        <h2 className='c-heading'>Reach more people</h2>
        <p className="c-note">Advertise your business with Click to WhatsApp Ads</p>
      </div>
      {stepNumber && stepNumber>2 ? <Progress step={stepNumber} /> : ""}
    </div>
  )
}

export default StepsHeadingSection